export const queryKeys = {
  ROBOTO_SIP: "ROBOTO_SIP",
  CREATE_SIP: "CREATE_SIP",
  CAMPAGING_ALL: "CAMPAGING_ALL",
  ONE_CAMPAGING: "ONE_CAMPAGING",
  CHANNEL_SHORT: "CHANNEL_SHORT",
  CREATE_ROBOTO_DEBT: "CREATE_ROBOTO_DEBT"
}